// German translations — primary language. Structure ready for it/en/fr.
export const de = {
  // Common
  common: {
    save: "Speichern",
    cancel: "Abbrechen",
    delete: "Löschen",
    confirm: "Bestätigen",
    create: "Erstellen",
    edit: "Bearbeiten",
    close: "Schliessen",
    back: "Zurück",
    next: "Weiter",
    loading: "Lädt...",
    search: "Suchen",
    name: "Name",
    email: "E-Mail",
    phone: "Telefon",
    password: "Passwort",
    date: "Datum",
    time: "Zeit",
    status: "Status",
    actions: "Aktionen",
    add: "Hinzufügen",
    remove: "Entfernen",
    yes: "Ja",
    no: "Nein",
    optional: "Optional",
    required: "Pflichtfeld",
    notes: "Notizen",
    allergies: "Allergien",
    guests: "Gäste",
    table: "Tisch",
    room: "Raum",
    service: "Service",
    or: "oder",
  },
  // Marketing
  marketing: {
    nav: { philosophy: "Philosophie", product: "Produkt", trial: "Testphase", login: "Anmelden" },
    hero: {
      eyebrow: "Hospitality Operating System",
      title_1: "Das Restaurant",
      title_2: "atmet ruhig,",
      title_3: "wenn alles fliesst.",
      subtitle: "SONARA ist die Operating-Plattform für Premium-Restaurants — entwickelt für Häuser, die ihren Gästen jeden Abend dieselbe stille Selbstverständlichkeit schenken wollen.",
      cta_primary: "30 Tage kostenlos starten",
      cta_secondary: "Philosophie ansehen",
    },
    philosophy: {
      eyebrow: "Philosophie",
      title: "Ein Haus. Ein Werkzeug.",
      body_1: "SONARA ist kein Reservierungssystem.",
      body_2: "Es ist die ruhige Hand hinter dem Service eines anspruchsvollen Restaurants — vom ersten Anruf bis zum letzten Gang.",
      body_3: "Wir glauben nicht an Pakete. Nicht an Stufen. Nicht an Funktionen, die hinter Preisschildern warten. Jedes Haus, das SONARA wählt, erhält die vollständige Edition — kompromisslos, vollständig, sofort.",
    },
    canvas: {
      eyebrow: "Die Werkzeuge",
      title: "Alles, was ein präzises Haus braucht.",
      body: "Reservierungsfluss, Lounge-Übergabe, interaktiver Raumplan, Service-Konfiguration, Team-Choreografie, Gäste-Geschichte, Analytics. Keine Add-ons. Keine Stufen. Eine Edition für alle.",
      lines: [
        "Reservierungen & Gästefluss",
        "Interaktiver Raumplan mit live Status",
        "Lounge Flow für ruhige Übergaben",
        "Service-Choreografie & Tisch-Kellner-Zuteilung",
        "Gäste-Historie & VIP-Erkennung",
        "Operative Analytics",
      ],
    },
    edition: {
      eyebrow: "Die Edition",
      title: "Eine Version.",
      title_2: "Für alle gleich.",
      body_1: "Jedes Restaurant, das SONARA wählt, erlebt dasselbe Werkzeug — keine Free-Variante, keine künstlichen Limits, keine SaaS-Stufen.",
      body_2: "Die ersten dreissig Tage sind unser Geschenk an Sie. Volle Edition. Kein eingeschränkter Demo-Modus. Sie arbeiten mit SONARA wie ein langjähriger Inhaber.",
      trial_label: "Testphase",
      trial_value: "30 Tage",
      trial_hint: "Vollständige Edition, kostenlos. Danach automatisch in die kostenpflichtige Hauptversion.",
    },
    cta: {
      title: "Wenn Ihr Haus bereit ist, beginnt SONARA.",
      subtitle: "Eröffnen Sie Ihre dreissigtägige Edition. Heute Abend kann es bereits beginnen.",
      primary: "30 Tage frei starten",
      secondary: "Öffentliche Buchung ansehen",
    },
    footer: { rights: "Alle Rechte vorbehalten.", tagline: "Hospitality Operating System." },
  },
  // Auth
  auth: {
    login: {
      title: "Willkommen zurück",
      subtitle: "Melden Sie sich in Ihrem SONARA-Konto an.",
      submit: "Anmelden",
      google: "Mit Google fortfahren",
      no_account: "Noch kein Konto?",
      register_link: "Jetzt registrieren",
    },
    register: {
      title: "Konto erstellen",
      subtitle: "Starten Sie mit SONARA Booking.",
      restaurant_name: "Restaurantname",
      submit: "Konto erstellen",
      have_account: "Bereits ein Konto?",
      login_link: "Anmelden",
    },
    logout: "Abmelden",
  },
  // Dashboard
  dashboard: {
    title: "Dashboard",
    today_reservations: "Heutige Reservierungen",
    active_tables: "Aktive Tische",
    lounge_waiting: "Lounge — Wartende",
    free_tables: "Freie Tische",
    upcoming: "Nächste Ankünfte",
    waiting_list: "Wartebereich Lounge",
    allergies_alerts: "Allergie-Hinweise",
    no_data: "Keine Daten verfügbar.",
  },
  // Sidebar
  nav: {
    dashboard: "Dashboard",
    reservations: "Reservierungen",
    floor_plan: "Raumplan",
    services: "Services",
    staff: "Team",
    lounge: "Lounge Flow",
    analytics: "Analytics",
    settings: "Einstellungen",
    admin: "SONARA Admin",
  },
  // Reservations
  reservations: {
    title: "Reservierungen",
    new: "Neue Reservierung",
    guest: "Gast",
    party: "Personen",
    type: "Anlass",
    types: {
      dinner: "Dinner",
      birthday: "Geburtstag",
      romantic: "Romantisches Dinner",
      business: "Geschäftsessen",
      family: "Familie",
      event: "Event",
    },
    statuses: {
      pending: "Ausstehend",
      confirmed: "Bestätigt",
      arrived: "Eingetroffen",
      waiting_lounge: "Wartet in Lounge",
      table_ready: "Tisch bereit",
      seated: "Platziert",
      completed: "Abgeschlossen",
      cancelled: "Storniert",
      no_show: "Nicht erschienen",
    },
    actions: {
      confirm: "Bestätigen",
      cancel: "Stornieren",
      arrive: "Eingetroffen",
      seat: "Platzieren",
      to_lounge: "In Lounge",
      table_ready: "Tisch bereit",
      complete: "Abschliessen",
      no_show: "No-Show",
    },
    empty: "Keine Reservierungen.",
    sources: {
      online: "Online",
      manual: "Manuell",
      phone: "Telefon",
      walk_in: "Walk-in",
      vip: "VIP",
    },
    group_by: "Gruppieren nach",
    group_by_options: {
      room: "Raum",
      table_waiter: "Tisch-Kellner",
    },
    no_group: "Ohne Zuordnung",
    no_waiter: "Ohne Kellner",
    add_manual: "Manuelle Buchung",
    manual_modal: {
      title: "Neue Buchung anlegen",
      subtitle: "Walk-in oder Telefon — den Gast in Ruhe erfassen.",
      source_label: "Quelle der Buchung",
      submit: "Buchung anlegen",
      saved: "Buchung erstellt",
    },
    detail: {
      back: "Zurück zur Übersicht",
      next_action: "Nächste Aktion",
      guest: "Gast",
      operational: "Operativ",
      history: "Besuchshistorie",
      not_found: "Reservierung nicht gefunden",
    },
    time_slots: {
      morning: "Vormittag",
      lunch: "Lunch",
      afternoon: "Nachmittag",
      aperitivo: "Aperitivo",
      dinner: "Dinner",
      late_night: "Late Night",
    },
  },
  // Floor plan
  floor: {
    title: "Raumplan",
    add_room: "Raum hinzufügen",
    add_table: "Tisch hinzufügen",
    select_room: "Raum wählen",
    room_name: "Raumname",
    room_type: "Raumtyp",
    table_name: "Tischname",
    seats: "Plätze",
    table_statuses: {
      free: "Frei",
      occupied: "Besetzt",
      reserved: "Reserviert",
      cleaning: "Reinigung",
      ready: "Bereit",
    },
    drag_hint: "Tipp: Tische lassen sich per Drag verschieben.",
  },
  // Services
  services: {
    title: "Service Creator",
    new: "Neuen Service erstellen",
    name: "Servicename",
    active_days: "Aktive Tage",
    start_time: "Startzeit",
    end_time: "Endzeit",
    table_duration: "Tischdauer (Min.)",
    interval: "Reservierungsintervall (Min.)",
    max_online: "Max. Online-Gäste",
    lounge_enabled: "Lounge erlaubt",
    allergies_required: "Allergien Pflicht",
    days_short: ["Mo", "Di", "Mi", "Do", "Fr", "Sa", "So"],
    empty: "Noch keine Services erstellt.",
  },
  // Staff
  staff: {
    title: "Team",
    new: "Mitarbeiter hinzufügen",
    role: "Rolle",
    roles: {
      owner: "Inhaber",
      manager: "Manager",
      host: "Host",
      waiter: "Kellner",
      bartender: "Barkeeper",
    },
    empty: "Noch keine Mitarbeiter.",
  },
  // Lounge
  lounge: {
    title: "Lounge Flow",
    waiting: "Wartende Gäste",
    transfer: "An Tisch übergeben",
    no_waiting: "Aktuell wartet niemand.",
    waiting_since: "Wartet seit",
  },
  // Analytics
  analytics: {
    title: "Analytics",
    total_reservations: "Reservierungen gesamt",
    completed: "Abgeschlossen",
    no_shows: "No-Shows",
    cancelled: "Storniert",
    returning: "Wiederkehrende Gäste",
    peak_hours: "Stosszeiten",
    seven_days: "Letzte 7 Tage",
  },
  // Settings
  settings: {
    title: "Einstellungen",
    general: "Allgemein",
    restaurant_name: "Restaurantname",
    address: "Adresse",
    tagline: "Tagline",
    description: "Beschreibung",
    booking_settings: "Buchungseinstellungen",
    guest_can_choose_table: "Gäste dürfen Tisch wählen",
    lounge_enabled: "Lounge aktiviert",
    confirmation_mode: "Bestätigungsmodus",
    confirmation_modes: { auto: "Automatisch", manual: "Manuell", smart: "Smart" },
    booking_link: "Öffentlicher Buchungslink",
    atmosphere: "Atmosphäre",
    atmosphere_hint: "Dein persönliches Erlebnis im Backoffice. Wird nur für dich gespeichert.",
    mode: "Modus",
    mode_day: "Day Mode",
    mode_night: "Night Mode",
    mode_day_desc: "Helle Hospitality-Oberfläche für Tagesbetrieb und Setup.",
    mode_night_desc: "Dunkle Lounge-Atmosphäre für Abendservice und Nightlife.",
    schedule: "Zeitplan",
    schedule_manual: "Manuell",
    schedule_auto: "Automatisch nach Uhrzeit",
    auto_day_start: "Day Mode ab",
    auto_night_start: "Night Mode ab",
  },
  // Public booking
  booking: {
    title: "Tisch reservieren",
    step_when: "Wann",
    step_who: "Wer",
    step_details: "Details",
    step_confirm: "Bestätigung",
    select_date: "Datum wählen",
    select_time: "Zeit wählen",
    party_size: "Anzahl Gäste",
    occasion: "Anlass",
    contact: "Ihre Kontaktdaten",
    full_name: "Vor- und Nachname",
    notes_placeholder: "Spezielle Wünsche, Geburtstag, Geschenk-Übergabe...",
    allergies_placeholder: "z.B. Gluten, Laktose, Nüsse, Schalentiere",
    submit: "Reservierung absenden",
    success_title: "Vielen Dank",
    success_text: "Ihre Reservierung wurde aufgenommen. Sie erhalten eine Bestätigung per E-Mail.",
    no_slots: "Für dieses Datum sind keine Zeiten verfügbar.",
    powered_by: "Powered by SONARA",
  },
  // Admin
  admin: {
    title: "SONARA Admin",
    restaurants: "Restaurants",
    total_restaurants: "Restaurants gesamt",
    total_users: "Nutzer gesamt",
    total_reservations: "Reservierungen gesamt",
    todays_reservations: "Heutige Reservierungen",
    owner: "Inhaber",
    slug: "Slug",
    created: "Erstellt",
    delete_confirm: "Restaurant wirklich löschen? Alle Daten gehen verloren.",
  },
};

export default de;
